import { ethers } from 'ethers'
import TOKEN_ARTIFACT from '../abis/Token.json';
import EXCHANGE_ARTIFACT from '../abis/Exchange.json';
import VAULT_ARTIFACT from '../abis/GoldVault.json';

const TOKEN_ABI = TOKEN_ARTIFACT.abi;
const EXCHANGE_ABI = EXCHANGE_ARTIFACT.abi;
const VAULT_ABI = VAULT_ARTIFACT.abi;

export const loadProvider = (dispatch) => {
  const connection = new ethers.providers.Web3Provider(window.ethereum)
  dispatch({ type: 'PROVIDER_LOADED', connection })

  return connection
}

export const loadNetwork = async (provider, dispatch) => {
  const { chainId } = await provider.getNetwork()
  dispatch({ type: 'NETWORK_LOADED', chainId })

  return chainId
}

export const loadAccount = async (provider, dispatch) => {
  const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
  const account = ethers.utils.getAddress(accounts[0])

  dispatch({ type: 'ACCOUNT_LOADED', account })

  let balance = await provider.getBalance(account)
  balance = ethers.utils.formatEther(balance)

  dispatch({ type: 'ETHER_BALANCE_LOADED', balance })

  return account
}

const loadSingleToken = async (provider, address) => {
  if (address === ethers.constants.AddressZero) {
    return { token: { address: ethers.constants.AddressZero }, symbol: 'ETH', decimals: 18 }
  }
  const token = new ethers.Contract(address, TOKEN_ABI, provider)
  const symbol = await token.symbol()
  const decimals = await token.decimals()
  return { token, symbol, decimals }
}

export const loadTokens = async (provider, addresses, dispatch) => {
  let result

  result = await loadSingleToken(provider, addresses[0])
  dispatch({ type: 'TOKEN_1_LOADED', token: result.token, symbol: result.symbol, decimals: result.decimals })

  result = await loadSingleToken(provider, addresses[1])
  dispatch({ type: 'TOKEN_2_LOADED', token: result.token, symbol: result.symbol, decimals: result.decimals })

  return result.token
}

export const loadExchange = async (provider, address, dispatch) => {
  const exchange = new ethers.Contract(address, EXCHANGE_ABI, provider);
  dispatch({ type: 'EXCHANGE_LOADED', exchange })

  return exchange
}

export const loadVault = async (provider, address, dispatch) => {
  const vault = new ethers.Contract(address, VAULT_ABI, provider);
  dispatch({ type: 'VAULT_LOADED', vault })

  return vault
}

export const loadMgtvToken = async (provider, address, dispatch) => {
  const mgtvToken = new ethers.Contract(address, TOKEN_ABI, provider);
  dispatch({ type: 'MGTV_TOKEN_LOADED', mgtvToken })

  return mgtvToken
}

export const loadVaultBalances = async (vault, mgtvToken, paxgToken, mgToken, account, dispatch) => {
  try {
    let paxgLocked = await vault.totalPaxgLocked()
    paxgLocked = ethers.utils.formatEther(paxgLocked)
    dispatch({ type: 'VAULT_PAXG_LOCKED_LOADED', paxgLocked })

    let mgtvBalance = await mgtvToken.balanceOf(account)
    mgtvBalance = ethers.utils.formatEther(mgtvBalance)
    dispatch({ type: 'MGTV_BALANCE_LOADED', balance: mgtvBalance })

    let paxgBalance = await paxgToken.balanceOf(account)
    paxgBalance = ethers.utils.formatEther(paxgBalance)
    dispatch({ type: 'VAULT_PAXG_BALANCE_LOADED', balance: paxgBalance })

    let mgBalance = await mgToken.balanceOf(account)
    mgBalance = ethers.utils.formatEther(mgBalance)
    dispatch({ type: 'VAULT_MG_BALANCE_LOADED', balance: mgBalance })
  } catch (error) {
    console.error('Error loading vault balances:', error)
  }
}

export const subscribeToEvents = (exchange, dispatch) => {


  exchange.on('Cancel', (id, user, tokenGet, amountGet, tokenGive, amountGive, timestamp, event) => {
    const order = event.args
    dispatch({type: 'ORDER_CANCEL_SUCCESS', order, event })
  })

  exchange.on('Trade', (id, user, tokenGet, amountGet, tokenGive, amountGive, creator, timestamp, event) => {
  const order = event.args
  dispatch({type: 'ORDER_FILL_SUCCESS', order, event })
  })


  exchange.on('Deposit', (token, user, amount, balance, event) => {
    dispatch({ type: 'TRANSFER_SUCCESS', event })
  })

  exchange.on('Withdraw', (token, user, amount, balance, event) => {
    dispatch({ type: 'TRANSFER_SUCCESS', event })
  })

  exchange.on('Order', (id, user, tokenGet, amountGet, tokenGive, amountGive, timestamp, event) => {
    const order = event.args
    dispatch({ type: 'NEW_ORDER_SUCCESS', order, event })
  })
}

// ------------------------------------------------------------------------------
// LOAD USER BALANCES (WALLET & EXCHANGE BALANCES)


export const loadBalances = async (exchange, tokens, account, dispatch, decimals) => {
  let balance

  if (tokens[0].address === ethers.constants.AddressZero) {
    balance = ethers.utils.formatEther(await exchange.provider.getBalance(account))
  } else {
    balance = ethers.utils.formatUnits(await tokens[0].balanceOf(account), decimals[0])
  }
  dispatch({ type: 'TOKEN_1_BALANCE_LOADED', balance })

  balance = ethers.utils.formatUnits(await exchange.balanceOf(tokens[0].address, account), decimals[0])
  dispatch({ type: 'EXCHANGE_TOKEN_1_BALANCE_LOADED', balance })

  if (tokens[1].address === ethers.constants.AddressZero) {
    balance = ethers.utils.formatEther(await exchange.provider.getBalance(account))
  } else {
    balance = ethers.utils.formatUnits(await tokens[1].balanceOf(account), decimals[1])
  }
  dispatch({ type: 'TOKEN_2_BALANCE_LOADED', balance })

  balance = ethers.utils.formatUnits(await exchange.balanceOf(tokens[1].address, account), decimals[1])
  dispatch({ type: 'EXCHANGE_TOKEN_2_BALANCE_LOADED', balance })

}


// ------------------------------------------------------------------------------
// LOAD ALL ORDERS

export const loadAllOrders = async (provider, exchange, dispatch) => {

  const block = await provider.getBlockNumber()

  // Fetch canceled orders
  const cancelStream = await exchange.queryFilter('Cancel', 0, block)
  const cancelledOrders = cancelStream.map(event => event.args)

  dispatch({ type: 'CANCELLED_ORDERS_LOADED', cancelledOrders })

  // Fetch filled orders
  const tradeStream = await exchange.queryFilter('Trade', 0, block)
  const filledOrders = tradeStream.map(event => event.args)

  dispatch({ type: 'FILLED_ORDERS_LOADED', filledOrders })

  // Fetch all orders
  const orderStream = await exchange.queryFilter('Order', 0, block)
  const allOrders = orderStream.map(event => event.args)

  dispatch({ type: 'ALL_ORDERS_LOADED', allOrders })
}


// ------------------------------------------------------------------------------
// TRANSFER TOKENS (DEPOSIT & WITHDRAWS)

export const transferTokens =  async (provider, exchange, transferType, token, amount, dispatch) => {
  let transaction

  dispatch({ type: 'TRANSFER_REQUEST' })

  try {
    const signer = await provider.getSigner()
    const decimals = await token.decimals()
    const amountToTransfer = ethers.utils.parseUnits(amount.toString(), decimals)

    if (transferType === 'Deposit') {
      transaction = await token.connect(signer).approve(exchange.address, amountToTransfer)
      await transaction.wait()
      transaction = await exchange.connect(signer).depositToken(token.address, amountToTransfer)
    } else {
      transaction = await exchange.connect(signer).withdrawToken(token.address, amountToTransfer)
    }

    await transaction.wait()

  } catch(error) {
    dispatch({ type: 'TRANSFER_FAIL' })
  }
}

// ------------------------------------------------------------------------------
// TRANSFER ETHER (DEPOSIT & WITHDRAW)

export const transferEther = async (provider, exchange, transferType, amount, dispatch) => {
  let transaction

  dispatch({ type: 'TRANSFER_REQUEST' })

  try {
    const signer = await provider.getSigner()
    const amountToTransfer = ethers.utils.parseUnits(amount.toString(), 18)

    if (transferType === 'Deposit') {
      transaction = await exchange.connect(signer).depositEther({ value: amountToTransfer })
    } else {
      transaction = await exchange.connect(signer).withdrawEther(amountToTransfer)
    }

    await transaction.wait()

  } catch(error) {
    dispatch({ type: 'TRANSFER_FAIL' })
  }
}

// ------------------------------------------------------------------------------
// ORDERS (BUY & SELL)

export const makeBuyOrder = async (provider, exchange, tokens, order, dispatch, decimals) => {
  const tokenGet = tokens[0].address
  const amountGet = ethers.utils.parseUnits(order.amount, decimals[0])
  const tokenGive = tokens[1].address
  const amountGive = ethers.utils.parseUnits((order.amount * order.price).toString(), decimals[1])

  dispatch({ type: 'NEW_ORDER_REQUEST' })

  try {
    const signer = await provider.getSigner()
    const transaction = await exchange.connect(signer).makeOrder(tokenGet, amountGet, tokenGive, amountGive)
    await transaction.wait()
  } catch (error) {
    dispatch({ type: 'NEW_ORDER_FAIL' })
  }
}

export const makeSellOrder = async (provider, exchange, tokens, order, dispatch, decimals) => {
  const tokenGet = tokens[1].address
  const amountGet = ethers.utils.parseUnits((order.amount * order.price).toString(), decimals[1])
  const tokenGive = tokens[0].address
  const amountGive = ethers.utils.parseUnits(order.amount, decimals[0])

  dispatch({ type: 'NEW_ORDER_REQUEST' })

  try {
    const signer = await provider.getSigner()
    const transaction = await exchange.connect(signer).makeOrder(tokenGet, amountGet, tokenGive, amountGive)
    await transaction.wait()
  } catch (error) {
    dispatch({ type: 'NEW_ORDER_FAIL' })
  }
}
export const cancelOrder = async (provider, exchange, order, dispatch) => {

  dispatch({ type: 'ORDER_CANCEL_REQUEST'})

  try {
    const signer = await provider.getSigner()
    const transaction = await exchange.connect(signer).cancelOrder(order.id)
    const receipt = await transaction.wait()

    const event = receipt.events.find(e => e.event === 'Cancel')

    dispatch({
      type: 'ORDER_CANCEL_SUCCESS',
      order,
      event
    })

  } catch (error) {
    console.log(error)
    dispatch({ type: 'ORDER_CANCEL_FAIL' })
  }
}

//--------------------------------------------------------------------------------------------------------------
//FILL ORDER
export const fillOrder = async (provider, exchange, order, dispatch) => {
  dispatch({ type: 'ORDER_FILL_REQUEST' })

  try {
    const signer = await provider.getSigner()
    const transaction = await exchange.connect(signer).fillOrder(order.id)
    await transaction.wait()

    dispatch({ type: 'ORDER_FILL_SUCCESS', order })

  } catch (error) {
    dispatch({ type: 'ORDER_FILL_FAIL' })
  }
}

// ------------------------------------------------------------------------------
// VAULT INTERACTIONS (MINT & REDEEM)

export const mintMG = async (provider, vault, paxgToken, mgtvToken, paxgAmount, useMgtv, dispatch) => {
  dispatch({ type: 'VAULT_REQUEST' })

  try {
    const signer = await provider.getSigner()
    const amount = ethers.utils.parseEther(paxgAmount.toString())

    // Approve PAXG to vault
    let transaction = await paxgToken.connect(signer).approve(vault.address, amount)
    await transaction.wait()

    // Approve MGTV if using discount
    if (useMgtv) {
      const mgtvAllowance = ethers.utils.parseEther('999999999')
      transaction = await mgtvToken.connect(signer).approve(vault.address, mgtvAllowance)
      await transaction.wait()
    }

    // Call vault.mint
    transaction = await vault.connect(signer).mint(amount, useMgtv)
    const receipt = await transaction.wait()

    const event = receipt.events.find(e => e.event === 'Mint')
    dispatch({ type: 'VAULT_SUCCESS', event })

  } catch (error) {
    console.error('Mint error:', error)
    dispatch({ type: 'VAULT_FAIL' })
  }
}

// ------------------------------------------------------------------------------
// SWAP via PARASWAP (aggregates Uniswap V2/V3 + other DEX liquidity)

const PARASWAP_API = 'https://apiv5.paraswap.io'
const PARASWAP_ETH = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE'

export const getSwapQuote = async (tokenIn, tokenOut, amountIn, srcDecimals, destDecimals, network = 1) => {
  const src = tokenIn === ethers.constants.AddressZero ? PARASWAP_ETH : tokenIn
  const dest = tokenOut === ethers.constants.AddressZero ? PARASWAP_ETH : tokenOut

  const params = new URLSearchParams({
    srcToken: src,
    destToken: dest,
    amount: amountIn.toString(),
    srcDecimals: srcDecimals.toString(),
    destDecimals: destDecimals.toString(),
    side: 'SELL',
    network: network.toString()
  })

  const res = await fetch(`${PARASWAP_API}/prices?${params}`)
  const data = await res.json()

  if (!res.ok || data.error) {
    throw new Error(data.error || 'Failed to get quote')
  }

  return data.priceRoute
}

export const executeSwap = async (provider, priceRoute, account, slippage, dispatch) => {
  dispatch({ type: 'SWAP_REQUEST' })

  try {
    const signer = await provider.getSigner()
    const isETHIn = priceRoute.srcToken.toLowerCase() === PARASWAP_ETH.toLowerCase()

    // Approve token if not ETH
    if (!isETHIn) {
      const proxy = priceRoute.tokenTransferProxy
      const tokenContract = new ethers.Contract(priceRoute.srcToken, [
        'function approve(address spender, uint256 amount) returns (bool)',
        'function allowance(address owner, address spender) view returns (uint256)'
      ], provider)

      const needed = ethers.BigNumber.from(priceRoute.srcAmount)
      const current = await tokenContract.allowance(account, proxy)
      if (current.lt(needed)) {
        if (current.gt(0)) {
          const resetTx = await tokenContract.connect(signer).approve(proxy, 0)
          await resetTx.wait()
        }
        const approveTx = await tokenContract.connect(signer).approve(proxy, ethers.constants.MaxUint256)
        await approveTx.wait()
      }
    }

    // Build transaction via Paraswap
    const txRes = await fetch(`${PARASWAP_API}/transactions/${priceRoute.network}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        srcToken: priceRoute.srcToken,
        destToken: priceRoute.destToken,
        srcAmount: priceRoute.srcAmount,
        priceRoute,
        userAddress: account,
        slippage: Math.floor(slippage * 100),
        partner: 'milligram'
      })
    })

    const txData = await txRes.json()
    if (!txRes.ok || txData.error) {
      throw new Error(txData.error || 'Failed to build swap transaction')
    }

    // Send the transaction
    const transaction = await signer.sendTransaction({
      to: txData.to,
      data: txData.data,
      value: ethers.BigNumber.from(txData.value || '0'),
      gasLimit: txData.gas ? ethers.BigNumber.from(txData.gas) : undefined
    })

    const receipt = await transaction.wait()
    dispatch({ type: 'SWAP_SUCCESS', txHash: receipt.transactionHash })

  } catch (error) {
    console.error('Swap error:', error)
    const reason = error?.reason || error?.data?.message || error?.message || 'Swap failed'
    dispatch({ type: 'SWAP_FAIL', error: reason })
  }
}

export const redeemMG = async (provider, vault, mgToken, mgtvToken, mgAmount, useMgtv, dispatch) => {
  dispatch({ type: 'VAULT_REQUEST' })

  try {
    const signer = await provider.getSigner()
    const amount = ethers.utils.parseEther(mgAmount.toString())

    // Approve MG to vault
    let transaction = await mgToken.connect(signer).approve(vault.address, amount)
    await transaction.wait()

    // Approve MGTV if using discount
    if (useMgtv) {
      const mgtvAllowance = ethers.utils.parseEther('999999999')
      transaction = await mgtvToken.connect(signer).approve(vault.address, mgtvAllowance)
      await transaction.wait()
    }

    // Call vault.redeem
    transaction = await vault.connect(signer).redeem(amount, useMgtv)
    const receipt = await transaction.wait()

    const event = receipt.events.find(e => e.event === 'Redeem')
    dispatch({ type: 'VAULT_SUCCESS', event })

  } catch (error) {
    console.error('Redeem error:', error)
    dispatch({ type: 'VAULT_FAIL' })
  }
}
